'use strict';

const baseEndpoint = `${window.location.protocol}//${window.location.host}/wp-json/wp/v2`;
const list = document.getElementById('loadMoreList');
const button = document.getElementById('loadMoreButton');
const footer = document.getElementById('loadMoreFooter');

let parentPage = 6;
let postsPerPage = null;
let nextPage = 1;
let postsTotal = 0;
let postsLoaded = 0;
let fullyLoaded = false;


/**
 *
 *
 */
const init = function () {

	if (list) {
		postsPerPage = parseInt(list.getAttribute('data-posts-per-page'));
	}

	if (button) {
		button.addEventListener('click', () => {
			get_posts();
		});
	}

	// simulate loading of preloaded dataset
	nextPage = 2;
	postsLoaded = postsPerPage;

};


/**
 *
 *
 *
 */
const removeLoadingClass = function () {

	const listItems = Array.prototype.slice.call(list.children);

	listItems.forEach(element => {
		element.classList.remove('is-loading');
	});

}

/**
 *
 *
 *
 */
const get_posts = function () {

	if (fullyLoaded) {
		return;
	}

	// GET http://lifesource2020.local/wp-json/wp/v2/media/?parent=6&per_page=12
	const endPoint = baseEndpoint + `/media/?parent=${parentPage}&per_page=${postsPerPage}&page=${nextPage}`;

	$.get(endPoint, function (data, status, request) {

		postsLoaded += data.length;
		postsTotal = request.getResponseHeader('x-wp-total');

		$.each(data, function (i, item) {

			let media = null;

			// check for medium_square image data
			if (typeof item.media_details.sizes.medium_square !== 'undefined') {
				media = item.media_details.sizes.medium_square;
			} else {

				console.log("There is no medium square size for this image:");
				console.log(item);

				if (typeof item.media_details.sizes.full !== 'undefined') {
					media = item.media_details.sizes.full;
				} else {
					console.log("There is no full size for this image:");
					console.log(item);
				}

			}

			if (media !== null) {

				const template = `
				<li class="quilt-list-item is-loading">
					<figure>
						<img class="screen-reader-text" src="${media.source_url}" height="${media.height}" width="${media.width}" alt="${item.alt_text}" />
						<figcaption>
							<a href="${item.link}" class="quilt-list-item__pad" style="background-image: url(${media.source_url});">
								<span class="screen-reader-text">${item.title.rendered}</span>
							</a>
						</figcaption>
					</figure>
				</li>
				`;

				list.insertAdjacentHTML('beforeend', template);

			}

		});

		if (postsTotal > postsLoaded) {
			nextPage += 1;
		} else {
			fullyLoaded = true;
			button.setAttribute('disabled', '');
			footer.style.display = 'none';
		}

	}).done(function () {

		// console.log( 'second success' );
		setTimeout(() => {
			removeLoadingClass();
		}, 200);

	}).fail(function () {

		console.log('There was a problem loading more posts...');
		console.log(endPoint);
		console.log(status);

	}).always(function () {

		// console.log( 'finished' );

	});

};


const api = {
	init: init
};

export default api;